export const generateTableHead = (type, sort) => {
  const headers = {
    main: [
      { title: 'User ID', code: 'id', access: true },
      { title: 'Affiliate', code: 'affiliate', access: true },
      { title: 'Affiliate status', code: 'affiliate_status', access: true },
      { title: 'Visits', code: 'visits', access: true },
      { title: 'Registrations', code: 'registrations', access: true },
      { title: 'Referrals', code: 'referrals', access: true },
      { title: 'Conversion rate', code: 'conversion_rate', access: true },
      { title: 'Total earnings', code: 'total_earnings', access: true },
      { title: 'Available earnings', code: 'available_earnings', access: true },
      { title: '', code: '', access: true },
    ],
    referrals: [
      { title: 'User ID', code: 'id', access: true },
      { title: 'Affiliate', code: 'affiliate', access: true },
      { title: 'Referral', code: 'referral', access: true },
      { title: 'Payments', code: 'payments', access: true },
      { title: 'Total commission', code: 'total_commission', access: true },
      { title: '', code: '', access: true },
    ],
    payouts: [
      { title: 'User ID', code: 'id', access: true },
      { title: 'Affiliate', code: 'affiliate', access: true },
      { title: 'Payout amount', code: 'payout_amount', access: true },
      { title: 'Created', code: 'created', access: true },
      { title: 'Updated', code: 'updated', access: true },
      { title: 'Status', code: 'status', access: true },
      { title: 'Mode', code: 'mode', access: true },
      { title: '', code: '', access: true },
    ],
  }

  if (headers[type]) {
    return headers[type]
      .filter((item) => item.access)
      .map((item) => {
        if (sort?.columns) {
          const sortColumn = sort.columns.find((column) => column.name === item.code);
          if (sortColumn) {
            return {
              ...item,
              ...sortColumn,
              sort: true,
            }
          }
        }
        return item;
      })
  }

  return []
};

export const generateTableBody = (type, item) => {
  switch (type) {
  case 'main':
    return [
      { type: 'id', value: item.id, access: true },
      { type: 'affiliate', value: item.affiliate, access: true },
      { type: 'referral_status', value: item.referral_name, access: true },
      { type: 'total_visits', value: item.total_visits, access: true },
      { type: 'total_referrals', value: item.total_referrals, access: true },
      { type: 'paid_referrals', value: item.paid_referrals, access: true },
      { type: 'conversion_rate', value: item.conversion_rate, access: true },
      { type: 'total_earnings', value: item.total_earnings, access: true },
      { type: 'unpaid_earnings', value: item.unpaid_earnings, access: true },
      { type: 'actions', value: null, class: 'td-caret', access: true },
    ].filter((item) => item.access);

  case 'referrals':
    return [
      { type: 'id', value: item.id, access: true },
      { type: 'referral', value: item.referral, access: true },
      { type: 'affiliate', value: item.affiliate, access: true },
      { type: 'payments', value: item.payments, access: true },
      { type: 'commission', value: item.commission, access: true },
      { type: 'actions', value: null, class: 'td-caret', access: true },
    ].filter((item) => item.access);

  case 'payouts':
    return [
      { type: 'user_id', value: item.user_id, access: true },
      { type: 'affiliate', value: item.affiliate, access: true },
      { type: 'amount', value: item.amount, access: true },
      { type: 'created', value: item.created, access: true },
      { type: 'updated', value: item.updated, access: true },
      { type: 'status', value: item.status_name, access: true },
      { type: 'mode', value: item.mode_name, access: true },
      { type: 'actions', value: null, class: 'td-caret', access: true },
    ].filter((item) => item.access);

  default:
    break;
  }
};

export const getItemActions = (item, access) => [
  {
    title: 'Enable Affiliate',
    id: 1,
    access: item?.access?.enable && access?.change_status,
  },
  {
    title: 'Disable Affiliate',
    id: 2,
    access: item?.access?.disable && access?.change_status,
  },
  {
    title: 'Approve',
    id: 3,
    access: item?.access?.change_status && access?.approve_payout,
  },
  {
    title: 'Reject',
    id: 4,
    access: item?.access?.change_status && access?.reject_payout,
  },
].filter((item) => item.access);

export const prepareConfirmBtnsText = (actionKey) => {
  switch (actionKey) {
  case 1:
    return {
      confirmBtnText: 'Enable',
      cancelBtnText: 'Cancel',
      submitStyle: 'primary',
    };

  case 2:
    return {
      confirmBtnText: 'Disable',
      cancelBtnText: 'Cancel',
    };

  default:
    return {
      confirmBtnText: '',
      cancelBtnText: '',
    };
  }
};
